export interface SignupPrefillSource {
  email: string | null;
  firstName: string | null;
  lastName: string | null;
}

export interface PricingInvitePrefillSource {
  targetEmail: string;
  firstName: string | null;
  lastName: string | null;
}

export function selectSignupPrefill(
  pricingInvite: PricingInvitePrefillSource | null,
  hubSpot: SignupPrefillSource | null,
) {
  const source = pricingInvite
    ? {
        email: pricingInvite.targetEmail,
        firstName: pricingInvite.firstName,
        lastName: pricingInvite.lastName,
      }
    : hubSpot;
  if (!source) return null;

  return {
    email: source.email ?? "",
    name: [source.firstName, source.lastName].filter(Boolean).join(" "),
  };
}
